export const fixedBytesToMegabytes = (bytes: number): number => {
	return Math.round(bytes * 0.001) / 1000;
};
